module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-bold-webfont.209d204e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-bold-webfont.woff
// module id = 383
// module chunks = 3